import maintenanceImg from "../../../assets/images/service/ev.jpeg";
import {
  Settings,
  Zap,
  Tool,
  Clock,
  ShieldCheck,
  Activity,
  ClipboardCheck,
  TrendingUp,
  Maximize,
  UserCheck,
  RefreshCcw,
  AlertTriangle
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function EVCSMaintenance() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Proactive <span className="green">EVCS Maintenance</span> & Technical Support
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise ensures 99.9% uptime for your charging infrastructure through 
                    comprehensive preventive maintenance, remote diagnostics, and rapid 
                    on-site technical intervention.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Scheduled preventive maintenance for AC & DC chargers</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>24/7 remote monitoring & firmware optimization</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Emergency breakdown support and component replacement</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={maintenanceImg}
                      alt="EVCS Machine Maintenance"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-tools"></i> Guaranteed Uptime
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">Maximizing ROI through Reliability</h3>
                    <p className="mb-3">
                      An EV charging station is only as good as its availability. Denial Enterprise provides specialized maintenance workflows designed to extend the lifecycle of your charging hardware. Our technicians conduct deep-dive inspections of power modules, connectors, and communication units to prevent common issues like overheating or software handshake failures.
                    </p>
                    <p className="mb-3">
                      As an authorized partner for major MNCs, we adhere to global service standards, ensuring that your public or private charging hubs meet all safety and performance benchmarks required for high-traffic usage.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Activity size={22} />
                        </span>
                        <span>Connector Health Checks & Thermal Scanning</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <RefreshCcw size={22} />
                        </span>
                        <span>Firmware Updates & OCPP Communication Audits</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Earthing & Surge Protection Device (SPD) Testing</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ClipboardCheck size={22} />
                        </span>
                        <span>Detailed Service Logs & Uptime Performance Reporting</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">Why Professional Maintenance Matters</h4>
                    <p className="mb-6">
                      Our structured maintenance plans reduce the total cost of ownership by identifying wear and tear early, preventing expensive charger replacements and lost revenue from downtime.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <Clock size={22} />
                        </span>
                        <span>Rapid response times for critical charger faults</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Extended hardware lifespan and peak efficiency</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <AlertTriangle size={22} />
                        </span>
                        <span>Elimination of safety hazards for EV users</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Settings size={22} />
                        </span>
                        <span>Customized Annual Maintenance Contracts (AMC)</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Support for multi-vendor charger portfolios</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Expert technicians trained on the latest DC fast-chargers</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}